module.exports = __webpack_public_path__ + "static/media/Norlines.4487f306.svg";